async function t(t){if(!t)return null;const{file:e,crop:a}=t;return e&&a?await createImageBitmap(e,a.x,a.y,a.width,a.height):null}export{t as default};
